import { Injectable } from '@angular/core';
import { DeviceDetails } from '../models/device-details';
import PackageConfig from '../../../../package.json'

@Injectable({
  providedIn: 'root',
})
export class DeviceDetailsService {
  constructor() {}

  public get(): DeviceDetails {
    const screenWidth = window.screen.width || 'unknown';
    const screenHeight = window.screen.height || 'unknown';
    const devicePixelRatio = window.devicePixelRatio || 'unknown';
    const inputDevices = [];
    if ('ontouchstart' in window) inputDevices.push('touchscreen');
    if (navigator.maxTouchPoints > 0) inputDevices.push('touch-enabled');
    if (window.PointerEvent) inputDevices.push('pointer-events');
    if (window.KeyboardEvent) inputDevices.push('keyboard');
    if ('onmousemove' in window) inputDevices.push('mouse');
    const screenOrientation = window.screen.orientation?.type || 'unknown';
    const appVersion = PackageConfig.version || 'unknown';

    return {
      'X-Screen-Width': `${screenWidth}`,
      'X-Screen-Height': `${screenHeight}`,
      'X-Device-Pixel-Ratio': `${devicePixelRatio}`,
      'X-Input-Devices': JSON.stringify(inputDevices),
      'X-Screen-Orientation': `${screenOrientation}`,
      'X-App-Version': appVersion,
    };
  }
}
